let config = {};

config.baseURL = 'https://api.copacol.innovareti.com.br/api/v1/';
config.normalURL = 'https://api.copacol.innovareti.com.br/';

config.envType = 'prod';
config.applicationName = 'Copacol - Gestão de Frotas - InnovareTI';
config.footerName = 'Copacol - Gestão de Frotas - InnovareTI';
config.datePickerColor = 'green';

export default config


// WEBPACK FOOTER //
// ./src/config/prod.js